import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SoccerTrainingPartTimeEmployee } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class SoccerTrainingPartTimeEmployeeService extends InfrastructureService<SoccerTrainingPartTimeEmployee> {
  protected readonly endpoint: string = '/SoccerTrainingPartTimeEmployees';

  constructor(protected http: HttpClient) {
    super(http);
  }

}
